/**
 * Sends the transition assessment into GoHighLevel via the workflow Inbound
 * Webhook trigger, so the team keeps the lead even when no meeting is
 * scheduled. Keys are snake_case and lists are comma-joined to match the
 * field mapping configured in the GHL workflow ("Turo Alternative" webhook).
 *
 * The subsequent calendar booking flows into GHL natively through the
 * LeadConnector widget and merges onto this contact by email — which is why
 * `email` must stay mapped to the standard contact Email field in GHL.
 */
const WEBHOOK_URL =
  'https://services.leadconnectorhq.com/hooks/5iYYPbRZ4Q8RrtEgZ77y/webhook-trigger/214307f0-5ac2-48b0-a304-dd12982a9cb4';

const join = (list) => (Array.isArray(list) && list.length ? list.join(', ') : '');

export async function saveTransitionLead(lead) {
  const attribution = lead.attribution || {};
  const payload = {
    first_name: lead.firstName.trim(),
    last_name: lead.lastName.trim(),
    email: lead.email.trim(),
    phone: lead.phone.trim(),
    business_email: lead.email.trim(),
    business_phone_number: lead.phone.trim(),
    company_name: lead.businessName.trim(),
    fleet_state: lead.state,
    fleet_count: Number(lead.fleetSize) || 0,
    fleet_turo_count: Number(lead.turoVehicleCount) || 0,
    fleet_vehicle_types: join(lead.vehicleTypes),
    turo_status: lead.turoStatus,
    transition_reasons: join(lead.transitionReasons),
    transition_timeline: lead.transitionTimeline,
    off_rent_insurance: join(lead.offRentInsurance),
    off_rent_interest: lead.offRentInterest,
    on_rent_interest: lead.onRentInterest,
    rental_types: join(lead.rentalTypes),
    roadside_interest: lead.roadsideInterest,
    existing_website: lead.existingWebsite,
    currently_direct: lead.currentlyDirect,
    rental_management: lead.rentalManagement,
    rental_agreement: lead.rentalAgreement,
    renter_verification: lead.renterVerification,
    needs_help_with: join(lead.needsHelpWith),
    source: 'turo-alternative',
    utm_source: attribution.utm_source || '',
    utm_medium: attribution.utm_medium || '',
    utm_campaign: attribution.utm_campaign || '',
    gclid: attribution.gclid || '',
    fbclid: attribution.fbclid || '',
    ref: attribution.ref || '',
    completed_at: new Date().toISOString(),
  };

  const res = await fetch(WEBHOOK_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    throw new Error(`Lead webhook responded ${res.status}`);
  }
  return { ok: true };
}

/**
 * The booking itself reaches GoHighLevel natively through the LeadConnector
 * calendar widget (and merges onto the contact by email), so opening the
 * calendar is only logged locally — posting it to the webhook again would
 * re-run the workflow and duplicate the team notification.
 */
export async function markTransitionMeetingBooked(email) {
  console.log('[rentid] transition assessment meeting booked', JSON.stringify({ email, meetingBooked: true }));
  return { ok: true };
}
